import React, { Fragment } from 'react'
import { Transition, Dialog } from '@headlessui/react'
import classNames from 'classnames'
import styles from '@/styles/components/navbar.module.scss'

const Modal = ({ isShow, body, handleClose, zIndex }) => {
  return (
    <Transition appear show={isShow} as={Fragment}>
      <Dialog as="div" className={classNames('relative', zIndex)} onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="transition ease-out duration-400"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <div className="fixed inset-0 h-screen" />
        </Transition.Child>
        <div className="fixed inset-0 overflow-hidden">
          <div className="relative flex items-center justify-center text-center">
            <Transition.Child
              as={Fragment}
              enter="transition ease-out duration-400"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Dialog.Panel
                className={classNames(
                  styles.footerImg,
                  'invisible maxMedium:visible p-2 w-[102%] h-screen text-left mt-20 bg-no-repeat bg-bottom bg-contain bg-black'
                )}
              >
                {body}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default Modal
